<div class="pipe-overlay" *ngIf="info" (click)="close()">
    <div class="pipe-modal" role="dialog" aria-modal="true" [class.pipe-modal--fit]="info.kind === 'suggested'"
        [attr.aria-label]="info.kind === 'arrived' ? 'Pipa entregada' : info.kind === 'suggested' ? 'Pipa sugerida' : 'Pipa en proceso'" (click)="$event.stopPropagation()">
        <div class="pipe-modal__header">
            <span class="pipe-modal__title" [ngClass]="'mobico-' + info.product">
                <i class="fa fa-truck" aria-hidden="true"></i>{{ info.kind === 'arrived' ? 'Pipa entregada' : info.kind === 'suggested' ? 'Pipa sugerida' : 'Pipa en proceso' }}
                <span class="pipe-status" [ngClass]="info.kind + ' mobico-' + info.product">{{ info.kind === 'arrived' ? 'Llegó' : info.kind === 'suggested' ? 'Sugerida' : 'En proceso' }}</span>
            </span>
            <button type="button" class="pipe-modal__x" aria-label="Cerrar" (click)="close()">&times;</button>
        </div>
        <div class="pipe-modal__body">
            <p class="pipe-modal__msg" *ngIf="loading">Cargando la solicitud…</p>
            <p class="pipe-modal__msg" *ngIf="error">No se pudo cargar la solicitud. Intenta de nuevo.</p>
            <!-- Pipa SUGERIDA (admin, solo lectura; Edey 15-oct): misma tabla tipo Excel con lo
                 que el motor sabe de ella. Sin PO ni estatus: todavía nadie la pide. -->
            <div class="pipe-xl" *ngIf="info.kind === 'suggested'">
                <table>
                    <thead>
                        <tr>
                            <th>Tipo</th><th>Estación</th><th>Producto</th><th>Fecha<br>sugerida</th>
                            <th>Pedir a más<br>tardar el</th><th class="num">Litros<br>sugeridos</th>
                            <th class="num">Inventario<br>hoy</th><th class="num">Venta<br>diaria</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><span class="pipe-type suggested" [ngClass]="'mobico-' + info.product">Sugerida</span></td>
                            <td class="txt">{{ info.stationName || '—' }}</td>
                            <td><span class="pipe-prod" [ngClass]="'mobico-' + info.product">{{ info.productLabel }}</span></td>
                            <td>{{ pipeDay(info.date) }}</td>
                            <td>{{ info.suggestion?.orderBy ? pipeDay(info.suggestion.orderBy) : '—' }}</td>
                            <td class="num">{{ info.liters != null ? (info.liters | number: '1.0-0') : '—' }}</td>
                            <td class="num">{{ info.suggestion?.stock != null ? (info.suggestion.stock | number: '1.0-0') : '—' }}</td>
                            <td class="num">{{ info.suggestion?.sale != null ? (info.suggestion.sale | number: '1.0-0') : '—' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- Compra capturada directo (sin FuelOrder detrás): no hay PO que mostrar. -->
            <ng-container *ngIf="!loading && !error && !orders.length && info.kind !== 'suggested'">
                <p class="pipe-modal__msg">Esta pipa no tiene solicitud en el flujo: se registró directo.
                    {{info.stationName}} · {{info.productLabel}} · {{info.liters | number: '1.0-0'}} lts · {{pipeDay(info.date)}}</p>
            </ng-container>
            <!-- Tabla tipo Excel con las columnas del Cronograma, en su MISMO orden
                 (Tipo · Estación · PO · Zona · Producto · Fecha de Solicitud · Material ·
                 Litros Solicitados · Fecha Requerida · Fecha de Entrega · Estatus del
                 viaje · Fecha de Registro · Litros Entregados · Costo Total · Costo
                 Litro). Sin Estado: necesita el catálogo de entidades de pipes. -->
            <div class="pipe-xl" *ngIf="orders.length">
                <table>
                    <thead>
                        <tr>
                            <th>Tipo</th><th>Estación</th><th>PO</th><th>Zona</th><th>Producto</th>
                            <th>Fecha de<br>Solicitud</th><th *ngIf="isMobicoAdmin">Material</th><th class="num">Litros<br>Solicitados</th>
                            <th>Fecha<br>Requerida</th><th>Fecha de<br>Entrega</th><th>Estatus<br>del viaje</th>
                            <th>Fecha de<br>Registro</th><th class="num">Litros<br>Entregados</th>
                            <th class="num" title="No incluye IVA, ni descuento">Costo<br>Total</th><th class="num">Costo<br>Litro</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let o of orders">
                            <td><span class="pipe-type" [ngClass]="o.pending_change_type || 'addition'">{{ typeLabels[o.pending_change_type || 'addition'] }}</span></td>
                            <td class="txt">{{o.station_name || info.stationName || '—'}}</td>
                            <td class="po">{{o.po_number || '—'}}</td>
                            <td>{{o.zone ? capitalize(o.zone) : '—'}}</td>
                            <td><span class="pipe-prod" [ngClass]="'mobico-' + info.product">{{info.productLabel}}</span></td>
                            <td>{{pipeDay(o.date)}}</td>
                            <!-- Material = concepto interno de MOBICO (16-oct): solo lo ve su admin. -->
                            <td class="txt" *ngIf="isMobicoAdmin">{{o.material || '—'}}</td>
                            <td class="num">{{(o.liters_requested ?? o.truck_capacity) != null ? ((o.liters_requested ?? o.truck_capacity) | number: '1.0-0') : '—'}}</td>
                            <td>{{pipeDay(o.expected_delivery_date || o.order_delivery_date)}}</td>
                            <td>{{pipeDay(o.delivery_date)}}</td>
                            <td><span *ngIf="o.delivery_status; else noTrip" class="pipe-trip" [ngClass]="tripClass(o)">{{tripLabel(o)}}</span><ng-template #noTrip>—</ng-template></td>
                            <td>{{pipeDay(o.registration_date)}}</td>
                            <td class="num">{{o.liters != null ? (o.liters | number: '1.0-0') : '—'}}</td>
                            <td class="num">{{o.total != null ? '$ ' + (o.total | number: '1.0-0') : '—'}}</td>
                            <td class="num">{{o.supply_price != null ? '$ ' + (o.supply_price | number: '1.2-2') : '—'}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="pipe-modal__footer">
            <button type="button" class="pipe-modal__btn" (click)="close()">Cerrar</button>
        </div>
    </div>
</div>
